import { React, useEffect, useState } from 'react';
import { Calendar } from 'antd';
import { ModifyModal, Button, Form, Input, Row, Col, DeletePopHover, Badge } from "../ui/ot";
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { XCircleIcon } from '@heroicons/react/solid';
import { CalendarGrid } from '../ui/calendar-grid'
import HolidayListForm from './holiday_list_form'
import { FileX } from 'lucide-react';
const getDefaultDateRange = (year = new Date().getFullYear()) => {

    const minDate = new Date(year, 0, 1);          // 該年的 1 月 1 日
    const maxDate = new Date(year, 11, 31);        // 該年的 12 月 31 日
    return { minDate, maxDate };
}
const HolidayDetailPicker = ({
    keyPrefix = "shift_management.holiday_overview.detail",
    year,
    holidayDatas,
    moreHolidayDatas,
    setHolidayDatas,
    setMoreHolidayDatas
}) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const [currentDate, setCurrentDate] = useState(new Date())
    const [dateRange, setDateRange] = useState(getDefaultDateRange(year))
    const [mode, setMode] = useState()
    const transformAllHolidayData = (holiday_setting_holiday_data, else_holiday_data) => {
        const officialHolidays = (holiday_setting_holiday_data ||[])
            .filter(item => item?.isholiday === "true") // 只取 isholiday == "true"
            .map(item => ({
                name: item?.description,
                color: "bg-yellow-200",
                date: item?.date
            }));

        const customHolidays = (else_holiday_data ||[])?.map(item => ({
            name: item?.description,
            color: "bg-blue-200",
            date: item?.date
        }));
        
        return [...officialHolidays, ...customHolidays]; // 合併兩個陣列
    }
    useEffect(() => {
        setDateRange(getDefaultDateRange(year))
    }, [year]);

    return (
        <>
            <Col span={24}>
                <Row gutter={[8, 8]}>
                    <Col xxl={8} xl={8} lg={24} md={24} sm={24} xs={24}>
                        <Row >
                            <Col span={24}>
                            {
                                console.log({
                                    holidayDatas, moreHolidayDatas
                                })
                            }
                                <CalendarGrid
                                    holidays={transformAllHolidayData(holidayDatas, moreHolidayDatas)}
                                    dateRange={dateRange}
                                    onDateChange={setCurrentDate}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={16} xl={16} lg={24} md={24} sm={24} xs={24}>
                        <HolidayList
                            year={year}
                            moreHolidayDatas={moreHolidayDatas}
                            setMoreHolidayDatas={setMoreHolidayDatas}
                            holidayDatas={holidayDatas}
                            setHolidayDatas={setHolidayDatas}
                            t={t}
                        >
                        </HolidayList>
                    </Col>
                </Row >
            </Col >
        </>
    )
}

const HolidayList = ({
    holidayDatas,
    setHolidayDatas,
    moreHolidayDatas,
    setMoreHolidayDatas,
    year,
    t,
}) => {
    // 獲取假期類型的樣式
    const getHolidayStyle = (type) => {
        if (type === "national") {
            return {
                card: "border-amber-200 bg-amber-50",
                badge: "bg-amber-100 text-amber-900 border-amber-300",
                header: "border-amber-600 text-amber-800",
                calendar: "bg-amber-100 text-amber-900",
            }
        } else {
            return {
                card: "border-blue-200 bg-blue-50",
                badge: "bg-blue-100 text-blue-800 border-blue-300",
                header: "border-blue-500 text-blue-700",
                calendar: "bg-blue-100 text-blue-800",
            }
        }
    }
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false)

    return (
        <Row>
            <ModifyModal
                axiosMode="post"
                propsForm={form}
                propsUseData={() => {
                    return {
                        postData: async (data) => {
                            setMoreHolidayDatas((pre) => {
                                return [...pre, ...data]
                            });
                            setOpen(false);
                            return true
                        },
                        patchData: async (data) => {

                        },
                        // deleteData: personalInformationController.deleteData,
                    }
                }}
                modalOpen={open}
                setModalOpen={setOpen}
                propsWidth={800}
                initialValues={{

                }}
                formMode={true}
                PropsPatchForm={<HolidayListForm
                    dateRange={{
                        min: `${year}-01-01`,
                        max: `${year}-12-31`
                    }}
                />}
            />
            <Col span={24}>
                {/* 假期類型圖例 */}
                <div className="flex items-center gap-4 mb-3 p-2 bg-gray-50 rounded">
                    <div className="flex items-center">
                        <Badge className="bg-amber-100 text-amber-900 border-amber-300 mr-2">{t('national_holiday')}</Badge>
                        <span className="text-base">{holidayDatas?.length} 天</span>
                    </div>
                    <div className="flex items-center">
                        <Badge className="bg-blue-100 text-blue-800 border-blue-200 mr-2">{t('custom_holiday')}</Badge>
                        <span className="text-base">{moreHolidayDatas?.length} 天</span>
                    </div>
                    <Button
                        onClick={() => {
                            form.resetFields()
                            form.setFieldsValue({ 'recordset': [{}] })
                            setOpen(true)
                        }}
                    >
                        {t('add_custom_holiday')}
                    </Button>
                </div>

                {/* 國定假日標題 */}
                <div className="border-l-4 border-amber-600 pl-2 mb-2">
                    <h3 className="text-base font-bold text-amber-800"> 
                         {t('national_holiday')}
                    </h3>
                </div>
            </Col>
            <Col span={24}>
                {/* 國定假日列表 - 兩列顯示 */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 mb-4">
                    {holidayDatas
                        ?.map((holiday, index) => {
                            const style = getHolidayStyle("national")
                            return (
                                <div
                                    key={holiday?.date}
                                    className={`flex items-center justify-between p-3 border rounded hover:bg-opacity-80 ${style.card}`}
                                >
                                    <div className="flex items-center">
                                        <Badge variant="outline" className={`mr-2 text-base px-2 py-1 ${style.badge}`}>
                                            {holiday?.description}
                                        </Badge>
                                        <span className="text-base">{holiday?.date}</span>
                                    </div>
                                    <div className="flex items-center">
                                        <span>{t('day_off')}：</span>
                                        <label className="inline-flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                value="true"
                                                checked={holiday?.isholiday === "true"}
                                                onChange={(e) => setHolidayDatas(prev => {
                                                    prev[index].isholiday = e.target.value;
                                                    return [...prev];
                                                })}
                                                className="form-radio text-blue-600"
                                            />
                                            <span>{`${t('is_holiday')}`}</span>
                                        </label>
                                        <label className="inline-flex items-center space-x-2 ml-4">
                                            <input
                                                type="radio"
                                                value="false"
                                                checked={holiday?.isholiday === "false"}
                                                onChange={(e) => setHolidayDatas(prev => {
                                                    prev[index].isholiday = e.target.value;
                                                    return [...prev];
                                                })}
                                                className="form-radio text-red-600"
                                            />
                                            <span>{`${t('not_holiday')}`}</span>
                                        </label>
                                    </div>
                                </div>
                            )
                        })}
                </div>
                {/* 自定義假日標題 */}
                <div className="border-l-4 border-blue-500 pl-2 mb-2">
                    <h3 className="text-base font-bold text-blue-700">{t('custom_holiday')}</h3>
                </div>
                {/* 自定義假日列表 - 兩列顯示 */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                    {moreHolidayDatas
                        ?.map((moreHoliday) => {
                            const style = getHolidayStyle("custom")
                            return (
                                <div
                                    key={moreHoliday?.date}
                                    className={`flex items-center justify-between p-3 border rounded hover:bg-opacity-80 ${style.card}`}
                                >
                                    <div className="flex items-center">
                                        <Badge variant="outline" className={`mr-2 text-base px-2 py-1 ${style.badge}`}>
                                            {moreHoliday?.description}
                                        </Badge>
                                        <span className="text-base">{moreHoliday?.date}</span>
                                    </div>
                                    <div className="flex items-center">
                                        <DeletePopHover
                                            onConfirm={() => {
                                                setMoreHolidayDatas((pre) => {
                                                    let preData = [...pre]
                                                    let newData = preData.filter((ele) => ele?.date !== moreHoliday?.date || ele?.description !== moreHoliday?.description)
                                                    return newData
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                </div>
                {!(moreHolidayDatas||[]).length && <div
                    className={
                        "flex flex-col items-center justify-center gap-3 rounded-md border-2 border-dashed p-6 text-center"
                    }
                >
                    <FileX className="h-8 w-8 text-muted-foreground" />
                    <span className="text-base font-medium">{t('no_custom_holiday_added')}</span>
                </div>}
            </Col>
            {/* <div className="space-y-4">
                {holidayDatas.map((item, index) => (
                    <Row key={index} gutter={[8, 8]}>
                        <Col lg={12} md={24} sm={24} xs={24}>
                            {item?.description}：{item?.date}
                        </Col>

                        <Col lg={12} md={24} sm={24} xs={24}>
                            <span>放假：</span>
                            <label className="inline-flex items-center space-x-2">
                                <input
                                    type="radio"
                                    value="true"
                                    checked={item?.isholiday === "true"}
                                    onChange={(e) => setHolidayDatas(prev => {
                                        prev[index].isholiday = e.target.value;
                                        return [...prev];
                                    })}
                                    className="form-radio text-blue-600"
                                />
                                <span>{`${t('is_holiday')}`}</span>
                            </label>
                            <label className="inline-flex items-center space-x-2 ml-4">
                                <input
                                    type="radio"
                                    value="false"
                                    checked={item?.isholiday === "false"}
                                    onChange={(e) => setHolidayDatas(prev => {
                                        prev[index].isholiday = e.target.value;
                                        return [...prev];
                                    })}
                                    className="form-radio text-red-600"
                                />
                                <span>{`${t('not_holiday')}`}</span>
                            </label>
                        </Col>
                    </Row>
                ))}
            </div> */}
        </Row>

    );
};

const CloseIcon = () => (
    <XCircleIcon className="w-6 h-6 text-red-500" />
);
export default HolidayDetailPicker;